import PropTypes from 'prop-types';
import React from 'react';

import StyledInfoGraphicGroup from './infoGraphicGroup.style';
import InfoGraphic from '../../molecules/info-graphic/infoGraphic';

const InfoGraphicGroup = ({ infographic: { infographics }, layout = 'horizontal' }) => (
  <StyledInfoGraphicGroup layout={layout}>
    {infographics.map(item => (
      <InfoGraphic
        key={item.id}
        vertical={layout === 'vertical'}
        {...item}
        className="infoGraphicGroup__item"
      />
    ))}
  </StyledInfoGraphicGroup>
);

InfoGraphicGroup.propTypes = {
  infographic: PropTypes.shape({
    infographics: PropTypes.arrayOf(PropTypes.shape())
  }).isRequired,
  layout: PropTypes.oneOf(['vertical', 'horizontal'])
};

export default InfoGraphicGroup;
